import '../styles/SocialMedia.css';
import { FaLinkedin, FaGithub } from 'react-icons/fa';

export default function SocialMedias({ type }) {

    return (

        <ul className='social_list'>

            <li>

                <a href='https://github.com/i-am-lucas-almeida' target='_blank' rel='noreferrer' className={type} title='Github'>
                    <FaGithub />
                </a>
                
            </li>

            <li>

                <a href='https://www.linkedin.com/in/lucas-almeida-galv%C3%A3o-920064185/' target='_blank' rel='noreferrer' className={type} title='LinkedIn'>
                    <FaLinkedin />
                </a>

            </li>

        </ul>

    )

}